// disable all logs
console.log = function(){};

$('.zinio-consent-age-requirement input').datepicker({
    format: "dd-mm-yyyy",
    calendarWeeks: true,
    toggleActive: false,
});

// delete modal
$('form[data-form="delete"]').on('click', function(e){
    //console.log('am clicked');
    e.preventDefault();
    var $form=$(this);
    $('#confirm').modal({ backdrop: 'static', keyboard: false })
        .on('click', '#delete-btn', function(){
            $form.submit();
        });
});

$('a[data-form="delete"]').on('click', function(e){
    //console.log('am clicked');
    e.preventDefault();
    var $url=$(this);
    $('#confirm').modal({ backdrop: 'static', keyboard: false })
        .on('click', '#delete-btn', function(){
            return window.location.href = $url.data('href');
        });
});

// publish modal
$('form[data-form="publish"]').on('click', function(e){
    e.preventDefault();
    var $form=$(this);
    $('#publish').modal({ backdrop: 'static', keyboard: false })
        .on('click', '#publish-btn', function(){
            $form.submit();
        });
});

// unpublish modal
$('form[data-form="unpublish"]').on('click', function(e){
    e.preventDefault();
    var $form=$(this);
    $('#unpublish').modal({ backdrop: 'static', keyboard: false })
        .on('click', '#unpublish-btn', function(){
            $form.submit();
        });
});

// activate modal
$('form[data-form="activate"]').on('click', function(e){
    e.preventDefault();
    var $form=$(this);
    $('#activate').modal({ backdrop: 'static', keyboard: false })
        .on('click', '#activate-btn', function(){
            $form.submit();
        });
});

// deactivate modal
$('form[data-form="deactivate"]').on('click', function(e){
    e.preventDefault();
    var $form=$(this);
    $('#deactivate').modal({ backdrop: 'static', keyboard: false })
        .on('click', '#deactivate-btn', function(){
            $form.submit();
        });
});

// make file default
$('form[data-form="make-default"]').on('click', function(e){
    e.preventDefault();
    var $form=$(this);
    $('#make-default').modal({ backdrop: 'static', keyboard: false })
        .on('click', '#make-default-btn', function(){
            $form.submit();
        });
});


$('div.alert').not('.alert-important').fadeIn( 300 ).delay( 2000 ).fadeOut( 4000 );

window.addEventListener('beforeinstallprompt', function (e) {
    e.preventDefault();
    toastr.options.timeOut = 0;
    toastr.options.extendedTimeOut = 0;
    toastr.options.preventDuplicates = true;
    toastr.options.closeButton = true;
    toastr.options.positionClass = "toast-bottom-center";
    toastr.options.onclick = function() {
        e.prompt();
        e.userChoice.then((choiceResult) => {
            if (choiceResult.outcome === 'accepted') {
                e = null;
            } else {
            }
        });
    };
    toastr.info(' Add Mgazeti to Homescreen');

});


window.onpageshow =function(event){
    if(event.persisted){
        //document.body.style.display ="none";
        location.reload();
    }
};

function disableButtonOnClick($this) {

    var prevText = $this.val();
    $this.val('Please wait..');
    $this.html = 'Please wait..';
    $this.attr('disabled', true);

}

function showProgressLoader($this){

    var prevText = $this.val();
    $this.val('Please wait..');
    $this.html='Please wait..';
    $this.attr('disabled', true);

    //console.log('am clicked');

    //hide previous modals
    $('.modal').modal('hide');

    // show persistent modal for processing info
    $('#savingInformation').modal({
        show: true,
        backdrop: 'static',
        keyboard: false
    });

    setTimeout(function() {
        $this.attr('disabled', false);
        $this.val(prevText);
        $this.html=prevText;
    }, 5000);
}


// submit button
$('.positive-submit').click(function () {
    // submit this form
    $(this).closest('form').submit();

    // append a spinner icon
    $(this).append($("<i class='fa fa-spinner fa-spin mg10r fa-2x'></i>"))
        .button();

    // disable this button
    $(this).attr('disabled', true);
    // disable other forms
    $( '.positive-submit').attr('disabled', true);
    //disableButtonOnClick($this);
});


// submit mpesa form
$('#button-mpesa-on-submit').click(function (event) {

    event.preventDefault();
    var $this = $(this);
    //console.log('am clicked', input, iti.isValidNumber(), iti.getNumber());

    if(iti.isValidNumber()){
        $('.formatted-phone-number-span')
            .addClass('hide')
            .removeClass('show');
        // submit the mpesa form
        $this.closest('form')
            .submit();
        // // show loader
        showProgressLoader($this);
    }else{
        $('.formatted-phone-number-span')
            .addClass('show')
            .removeClass('hide');
    }

    // var $this = $(this);
    // // submit the mpesa form
    // $( '#form-mpesa-submit-custom').submit();
    // // show loader
    // showProgressLoader($this);

});

// submit dpo form
$('#button-dpo-on-submit').click(function () {
    var $this = $(this);
    // submit the mpesa form
    $( '#form-dpo-submit-custom').submit();
    // show loader
    showProgressLoader($this);

});
// submit payments form
$('.button-payment-on-submit').click(function () {
    var $this = $(this);
    // submit the mpesa form
    $(this).closest('form').submit();
    // show loader
    showProgressLoader($this);

});

var isChrome = navigator.userAgent.indexOf('Chrome') > -1;
var isExplorer = navigator.userAgent.indexOf('MSIE') > -1;
var isFirefox = navigator.userAgent.indexOf('Firefox') > -1;
var isSafari = navigator.userAgent.indexOf("Safari") > -1;
var isOpera = navigator.userAgent.toLowerCase().indexOf("op") > -1;

// if ((isChrome)&&(isSafari)) { isSafari = false; }
// if ((isChrome)&&(isOpera)) { isChrome = false; }

// if (isSafari) { alert('Safari'); }

//var socialAuthParent = document.querySelector('#social-auth-parent');
// var socialAuthSection = document.querySelector('.social-auth-section');
// var socialAuthSeparator = document.querySelector('.social-auth-section-separator');
// var socialAuthTerms = document.querySelector('#social-auth-terms');
//var socialAuthParent = $('#social-auth-parent');

// the start
//
// var socialAuthSection = $('#social-auth-parent').find('.social-auth-section');
// var socialAuthSeparator = $('#social-auth-parent').find('.social-auth-section-separator');
// var socialAuthTerms = $('#social-auth-parent').find('#social-auth-terms');
//
// if (navigator.userAgent.indexOf('Safari') != -1 && navigator.userAgent.indexOf('Chrome') == -1) {
//
//     if((socialAuthSection !== null) && (socialAuthSeparator !== null) && (socialAuthTerms !== null)){
//         // socialAuthSection.remove();
//         // socialAuthSeparator.remove();
//         //
//         // // add inner html
//         // socialAuthTerms.innerHTML += '';
//
//     }
// }else{
//
//     if((socialAuthSection !== null) && (socialAuthSeparator !== null) && (socialAuthTerms !== null)){
//
//         // remove class to show it
//         socialAuthSection.removeClass('hide-im');
//         // add html to this class
//         socialAuthSection.prepend('<div class="flex-auto pg0a flex-column flex-align-space-between flex-vertical-center social-auth-section \'width-f}}">\n' +
//             '    <div class="flex-nogrow width-f mg10tb">\n' +
//             '        <a href="/login/google" class="btn bg-gm crff textl width-f pg10tb" style="min-width: 250px; max-width: 100%">\n' +
//             '            <i class="fa mg10r fa-google"></i>\n' +
//             '            <span class="font15px social-login">Login With</span>\n' +
//             '            <span class="font15px social-signup">Sign Up With</span>\n' +
//             '            <span class="font15px">Google</span>\n' +
//             '        </a>\n' +
//             '    </div>\n' +
//             '    <div class="flex-nogrow width-f mg10tb">\n' +
//             '        <a href="/login/facebook" class="btn bg-fb crff textl width-f pg10tb" style="min-width: 250px; max-width: 100%">\n' +
//             '            <i class="fa mg10r fa-facebook"></i>\n' +
//             '            <span class="font15px social-login">Login With</span>\n' +
//             '            <span class="font15px social-signup">Sign Up With</span>\n' +
//             '            <span class="font15px">Facebook</span>\n' +
//             '        </a>\n' +
//             '    </div>\n' +
//             '    <div class="flex-nogrow width-f mg10tb">\n' +
//             '        <a href="/login/twitter" class="btn bg-tw crff textl width-f pg10tb" style="min-width: 250px; max-width: 100%">\n' +
//             '            <i class="fa mg10r fa-twitter"></i>\n' +
//             '            <span class="font15px social-login">Login With</span>\n' +
//             '            <span class="font15px social-signup">Sign Up With</span>\n' +
//             '            <span class="font15px">Twitter</span>\n' +
//             '        </a>\n' +
//             '    </div>\n' +
//             '</div>' +
//             '<div class="flex-nogrow width-f mg10b ">' +
//             '<span class="font10px" style="color: #999">\n' +
//             '            By clicking "Sign Up / Login" or "Sign Up /\n' +
//             '            Login with Google/Facebook/Twitter" above,\n' +
//             '            you acknowledge that you have read,\n' +
//             '            understood, and agree to Mgazeti\'s\n' +
//             '            <a href="terms-and-conditions" class="cr-crl font10px">Terms & Conditions.</a>\n' +
//             '        </span>' +
//             '</div>');
//
//         // remove class to show it
//         socialAuthSeparator.removeClass('hide-im');
//         // add html to this class
//         socialAuthSeparator.prepend('<div class="flex-row flex-align-center flex-vertical-center social-or pg20lr">\n' +
//             '                                       <span>OR</span>\n' +
//             '                                    </div>');
//         socialAuthTerms.remove();
//     }
//
// }

// the end

// var isChrome = navigator.userAgent.indexOf('Chrome') > -1;
// var isSafari = navigator.userAgent.indexOf("Safari") > -1;
//
// if (isSafari){
//     if (isChrome){
//     }
//     else{
//         //return true;
//         document.querySelector('.social-auth-section').remove();
//         document.querySelector('.social-auth-section-separator').remove();
//     }
//
// }


// var isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
//
// // remove this section if set to true
// if(isSafari){
//     document.querySelector('.social-auth-section').remove();
//     document.querySelector('.social-auth-section-separator').remove();
// }
//console.log(isSafari, 'adsfadsf am home niggah');


var input = document.querySelector('.phone-number');
//var output = document.querySelector(".formatted-phone-number");

if(input !== null){
    var iti = window.intlTelInput(input, {
        //any initialisation options go here
        allowDropdown: true,
        autoHideDialCode: false,
        autoPlaceholder: 'polite',
        dropdownContainer: document.body,
        //excludeCountries: ['us'],
        formatOnDisplay: false,
        initialCountry: 'auto',
        geoIpLookup: function(callback) {
            $.get('https://ipinfo.io', function() {}, 'jsonp')
                .always(function(resp) {
                    var countryCode = (resp && resp.country) ? resp.country : 'ke';
                    callback(countryCode);
                });
        },
        // hiddenInput: 'full_number',
        localizedCountries: { 'ke': 'Kenya' },
        nationalMode: false,
        //onlyCountries: ['us', 'gb', 'ch', 'ca', 'do'],
        placeholderNumberType: 'MOBILE',
        preferredCountries: ['ke'],
        separateDialCode: false,
        setNumber: input,
        utilsScript: '/cdn/plugins/intl-tel-input-17.0.0/build/js/utils.js?0000000001',
    });

    var handleChange = function() {
        var text = (iti.isValidNumber()) ? 'International: ' + iti.getNumber() : 'Please enter a number below';
        var textNode = document.createTextNode(text);
        // output.innerHTML = ';
        // output.appendChild(textNode);
        input.val = iti.getNumber();
    };

// listen to 'keyup', but also 'change' to
// update when the user selects a country

    input.addEventListener('change', handleChange);
    input.addEventListener('keyup', handleChange);

}else{

}


// submit profile form
$('#button-profile-on-submit').click(function (event) {
    event.preventDefault();
    var $this = $(this);
    console.log('am clicked', input, iti.isValidNumber(), iti.getNumber());

    if(input !== null){
        if(iti.isValidNumber()){
            $('.formatted-phone-number-span')
                .addClass('hide')
                .removeClass('show');
            // submit the mpesa form
            $( '#form-profile-submit-custom')
                .closest('form')
                .submit();
            // // show loader
            showProgressLoader($this);
        }else{
            $('.formatted-phone-number-span')
                .addClass('show')
                .removeClass('hide');
        }
    }else{
        // submit the mpesa form
        $( '#form-profile-submit-custom')
            .closest('form')
            .submit();

        // // show loader
        showProgressLoader($this);
    }
});

// $('#form-mpesa-submit-custom').submit(function (evt) {
//     evt.preventDefault();
//     console.log('am clicked', input, iti.isValidNumber(), iti.getNumber());
//
// });


$('.submit_wide').click(function () {
    var $this = $(this);
    var prevText = $this.val();
    $this.val('Please wait..');
    $this.attr('disabled', true);
    setTimeout(function() {
        $this.attr('disabled', false);
        $this.val(prevText);
    }, 2000);
});

$(document).ready(function () {

    $(".clickable-row").click(function() {
        window.location = $(this).data("href");
    });

    // check if the button is available
    var sideMenuButton = document.querySelector('.navbar-nav-left');

    if(sideMenuButton !== null){
        $('.navbar-nav-left').mdStrap();
    }

    $('.date-container.input-daterange').datepicker({
        format: "yyyy-mm-dd",
        // startDate: "now",
        calendarWeeks: true,
        toggleActive: true
    }).on('change', function(){
        $('.datepicker-dropdown').hide();
    });

    $('#filepicker').on("change", function(event) {
        console.log('something has changed');
        let output = document.getElementById("listing");
        let files = event.target.files;

        for (let i=0; i<files.length; i++) {
            let item = document.createElement("li");
            item.innerHTML = files[i].webkitRelativePath;
            output.appendChild(item);
        };
    }, false);
    // initialize select 2
    $('.select2-js').select2();

    // initialize select 2 tags
    $('.select2-js-tags').select2({
        tags: true
    });

    $('.datepickeronly').datetimepicker({
        format: 'L'
    });

    $('.datePickeronlyCurrent').datetimepicker({
        format: 'L',
        minDate: true
    });

    $('.datepickeronly-inline').datetimepicker({
        inline: true,
        sideBySide: true
    });

    $('.datetimepicker').datetimepicker({
        sideBySide: true,
        icons: {
            time: 'fa fa-clock-o',
            date: 'fa fa-calendar',
            up: 'fa fa-arrow-up',
            down: 'fa fa-arrow-down'
        }
    });

    function socialAuth(login){

        if(login){
            $('.social-login').addClass('show2').removeClass('hide');
            $('.social-signup').addClass('hide').removeClass('show2');
        }else{
            $('.social-login').addClass('hide').removeClass('show2');
            $('.social-signup').addClass('show2').removeClass('hide');
        }
    };

    socialAuth(true);

    // run when the checkbox is clicked
    $($('.login-link').click((event) => {
        event.preventDefault();
        socialAuth(true);
    }));

    // run when the checkbox is clicked
    $($('.register-link').click((event) => {
        event.preventDefault();
        socialAuth(false);
    }))


    function checkLevel(){
        var level = $('input[name="level"]');
        if (level.is(':checked')) {
            $('#registerFrom').show();
            //console.log('am checked');
        } else {
            $('#registerFrom').hide();
            //console.log('not checked');
        }
    };

    // run onpage load
    checkLevel()

    // run when the checkbox is clicked
    $($('input[name="level"]').change((event) => {
        event.preventDefault();
        checkLevel();
    }));

    // recurrent payment

    function recurrentPayment(){
        var level = $('input[name="recurrent_billing"]');
        if (level.is(':checked')) {
            $('.recurrent_status').val('yes');
            //console.log('am checked',  $('.recurrent_status').val());
        } else {
            $('.recurrent_status').val('no');
            //console.log('not checked', $('.recurrent_status').val());
        }
    };

    // run onpage load
    recurrentPayment();

    // run when the checkbox is clicked
    $($('input[name="recurrent_billing"]').change((event) => {
        event.preventDefault();
        recurrentPayment();
    }));


    $('.date-container.input-group.date').datepicker({
        format: "yyyy-mm-dd",
        calendarWeeks: true,
        toggleActive: true
    });

    $('.date-container.input-daterange').datepicker({
        format: "yyyy-mm-dd",
        startDate: "now",
        calendarWeeks: true,
        toggleActive: true
    });

    $('.month-container.input-daterange').datepicker({
        format: "yyyy-mm",
        minViewMode: 1,
        calendarWeeks: true,
        toggleActive: true
    });

    $('.year-container.input-daterange').datepicker({
        format: "yyyy",
        minViewMode: 2,
        calendarWeeks: true,
        toggleActive: true
    });

    $('.year-founded-container.input-daterange').datepicker({
        format: "yyyy",
        endDate: "now",
        minViewMode: 2,
        calendarWeeks: true,
        toggleActive: true
    });

    // more pricing option
    // $('.button-on-submit').click(function(){
    //     console.log('amam asdfasdfads asdfasdfdas');
    //     this.disabled=true;
    //     this.innerText='Sending…';
    // });

    // more pricing option
    $('#more-pricing-issue-show').click(function(){
        $('#more-pricing-issue-show').hide();
        $('#more-pricing-issue-list').show();
    });


    // billing cycle function
    function billingCyclePublication(){
        var filter = $('.billing_cycle select').val();
        //console.log(filter, 'am here');
        if (filter === 'free') {
            $('#pricing').hide();
        } else {
            $('#pricing').show();
        }
    }
    // check onload
    billingCyclePublication();


    // run onchange
    $('.billing_cycle select').change((event) => {
        event.preventDefault();
        billingCyclePublication();
    });

    // file type function
    function fileTypeIssue() {
        var filter = $('.file_type select').val();
        if (filter === 'pdf') {
            $('#cover_image').hide();
        } else {
            $('#cover_image').show();
        }
    }
    // run it on load
    fileTypeIssue();

    // run onchange
    $('.file_type select').change((event) => {
        event.preventDefault();
        fileTypeIssue();
    });

    //change file uplaod function
    function fileUploadChangeIssue() {
        var filter = $('.issue-select-change').val();

        if (filter === 'pdf') {
            $('#issue_select_pdf').addClass('show').removeClass('hide');
            $('#issue_select_epub').addClass('hide').removeClass('show');
            $('#issue_select_html5').addClass('hide').removeClass('show');
        } else if(filter === 'epub') {
            $('#issue_select_pdf').addClass('hide').removeClass('show');
            $('#issue_select_epub').addClass('show').removeClass('hide');
            $('#issue_select_html5').addClass('hide').removeClass('show');
        } else if(filter === 'html5') {
            $('#issue_select_pdf').addClass('hide').removeClass('show');
            $('#issue_select_epub').addClass('hide').removeClass('show');
            $('#issue_select_html5').addClass('show').removeClass('hide');
        } else{
            $('#issue_select_pdf').addClass('show').removeClass('hide');
            $('#issue_select_epub').addClass('hide').removeClass('show');
            $('#issue_select_html5').addClass('hide').removeClass('show');
        }

        //console.log(filter, 'adsfasdf asdfadsf asdfasdfasd');
    }
    // run it on load
    fileUploadChangeIssue();


    // run onchange
    $('.issue-select-change').change((event) => {
        event.preventDefault();
        fileUploadChangeIssue();
    });

    $('.finance_option select').change((event) => {
        event.preventDefault();
        $('#bank_section div').remove();
        $('#mobile_money_section div').remove();

    });

    // mobile money function
    function mobileMoneyFunction(){
        var filter = $('.mobile_money_method select').val();
        if (filter === 'PayBill') {
            $('#mobile_money_method').show();
        } else {
            $('#mobile_money_method').hide();
        }
    }

    // run onload
    mobileMoneyFunction();
    // run onchange
    $('.mobile_money_method select').change((event) => {
        event.preventDefault();
        mobileMoneyFunction();
    });

});

window.onload = function () {
    var ios = /iPad|iPhone|iPod/.test(navigator.platform);

    // console.log(ios, navigator.platform, 'adsfadsf');
    //hide notifications link for ios devices
    if (!ios) {
        let notificationsLink = document.getElementById('notifications_link');
        if (notificationsLink) {
            notificationsLink.classList.remove('hide');
        }
    }
};

//
// const togglePassword = document.querySelector('#togglePassword');
// const password = document.querySelector('#id_password');
//
// togglePassword.addEventListener('click', function (e) {
//     // toggle the type attribute
//     const type = password.getAttribute('type') === 'password' ? 'text' : 'password';
//     password.setAttribute('type', type);
//     // toggle the eye slash icon
//     this.classList.toggle('fa-eye-slash');
// });

